import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { ErrorMessages } from '../../types'

const defaultLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE
// NOTE: The US values are NOT converted from the mm values. The US shop works in inches and has its
// own min / max limits, so they intentionally do not match a mm -> inch conversion
// (e.g. 585 mm ≈ 23.03 in, but the US max width is 24 in).
// Do not replace them with mmToInches() - update each value separately if a limit changes.
const minValue = defaultLocale === 'us' ? 0.75 : 19
const maxWidth = defaultLocale === 'us' ? 24 : 585
const maxHeight = defaultLocale === 'us' ? 11.5 : 308
const defaultValue = defaultLocale === 'us' ? '1.57' : '40'

export const fileCheckerSchema = (texts: ErrorMessages) => {
  const formSchema = z.object({
    sorts: z
      .string()
      .min(1, texts.required)
      .refine((value) => !isNaN(Number(value)) && Number(value) > 0, {
        message: texts.required
      }),
    height: z
      .string()
      .default(defaultValue)
      .refine((value) => !isNaN(Number(value)) && Number(value) >= minValue && Number(value) <= maxHeight, {
        message: texts.height_error
      }),
    width: z
      .string()
      .default(defaultValue)
      .refine((value) => !isNaN(Number(value)) && Number(value) >= minValue && Number(value) <= maxWidth, {
        message: texts.width_error
      }),
    foil: z.string(),
    opaque: z.string()
  })
  return formSchema
}

export const schemaResolver = (texts: ErrorMessages) => zodResolver(fileCheckerSchema(texts))
